import {
  FocusLock
} from "./chunk-CG74IXYP.mjs";
export {
  FocusLock
};
